module.exports = __webpack_public_path__ + "img/ep-G-dosis.e16ab7de.jpg";